<h2 fxLayoutAlign="space-between">
    <span>Users</span>
</h2>
<mat-card>
    <mat-card-content>
        <mat-table [dataSource]="allUsers" matSort (matSortChange)="sortUsers($event)" *ngIf="!loadingUsers" #usersTable>

            <ng-container matColumnDef="username">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Username</mat-header-cell>
                <mat-cell mat-cell *matCellDef="let user" style="text-overflow: ellipsis;">
                    <p style="text-overflow: ellipsis;">{{user.username}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{user.email}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="rpmAvatarURL">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Avatar URL</mat-header-cell>
                <mat-cell *matCellDef="let user" style="word-break: break-all;">
                    <span *ngIf="user.rpmAvatarURL != null">{{user.rpmAvatarURL}}</span>
                    <mat-progress-bar *ngIf="user.rpmAvatarURL == null" mode="indeterminate"></mat-progress-bar>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let user" fxLayoutAlign="end center">
                    <button mat-button (click)="editUser(user)"><mat-icon>edit</mat-icon></button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="['username', 'email', 'rpmAvatarURL', 'actions']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['username', 'email', 'rpmAvatarURL', 'actions'];"></mat-row>

        </mat-table>
        <mat-spinner *ngIf="loadingUsers" style="margin: 0 auto;"></mat-spinner>
    </mat-card-content>
</mat-card>